import { IconNameT } from '@cad-arc';
import { BoloPanelFormType, CadFeatureMap } from '@mark43/cad-api';
import { FieldPath } from 'react-hook-form';
import { BoloRelatedDataTab } from '../../related-data/bolo-related-data-tab';
import { BoloPanelVehiclesTab } from '../panel-components/tabs/entities/bolo-panel-vehicles-tab';
import { BoloPanelPersonsTab } from '../panel-components/tabs/entities/bolo-panel-persons-tab';
import { BoloDetailsTab } from '../panel-components/tabs/details/bolo-details-tab';
import { BoloLogTab } from '../panel-components/tabs/bolo-log/bolo-log-tab';
import { BoloAttachmentsTab } from '../panel-components/tabs/attachments/bolo-attachments-tab';

export type BoloPanelTab =
    | 'VEHICLES'
    | 'PERSONS'
    | 'RELATED_DATA'
    | 'BOLO_DETAILS'
    | 'BOLO_LOG'
    | 'MEDIA_ATTACHMENTS';

export type BoloPanelTabConfigBase = {
    name: string;
    type: BoloPanelTab;
    icon: IconNameT;
    component: React.FC;
    errorFields?: FieldPath<BoloPanelFormType>[];
    showOnNewPanel?: boolean;
    checkEnabled?: (enabledFeatures: CadFeatureMap) => boolean;
};

export const boloPanelTabConfig: Record<BoloPanelTab, BoloPanelTabConfigBase> = {
    BOLO_DETAILS: {
        name: 'BOLO Details',
        type: 'BOLO_DETAILS',
        icon: 'Bolo',
        component: BoloDetailsTab,
        showOnNewPanel: true,
    },
    RELATED_DATA: {
        name: 'Related Data',
        type: 'RELATED_DATA',
        icon: 'Document',
        component: BoloRelatedDataTab,
        showOnNewPanel: true,
    },
    MEDIA_ATTACHMENTS: {
        name: 'Attachments',
        type: 'MEDIA_ATTACHMENTS',
        icon: 'Paperclip',
        component: BoloAttachmentsTab,
        checkEnabled: (enabledFeatures) => enabledFeatures.mediaAttachmentsEnabled,
    },
    VEHICLES: {
        name: 'Vehicles',
        type: 'VEHICLES',
        icon: 'Vehicle',
        component: BoloPanelVehiclesTab,
    },
    PERSONS: {
        name: 'Persons',
        type: 'PERSONS',
        icon: 'Person',
        component: BoloPanelPersonsTab,
    },
    BOLO_LOG: {
        name: 'BOLO Log',
        type: 'BOLO_LOG',
        icon: 'History',
        component: BoloLogTab,
    },
};
